import { render, staticRenderFns } from "./auth_code.vue?vue&type=template&id=1221956c&"
import script from "./auth_code.vue?vue&type=script&lang=js&"
export * from "./auth_code.vue?vue&type=script&lang=js&"
import style0 from "./auth_code.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports